(function () {
  'use strict';
  /* Comprar ahora desde el catálogo y agregar rutinas completas. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bx-buy],[data-bx-routine]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var single = b.hasAttribute('data-bx-buy');
    var ids = (b.getAttribute(single ? 'data-bx-buy' : 'data-bx-routine') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var label = b.textContent;
    b.disabled = true;
    b.textContent = 'Agregando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      window.location.href = single ? '/checkout' : '/cart';
    }).catch(function () {
      b.textContent = 'No se pudo agregar';
      setTimeout(function () { b.textContent = label; b.disabled = false; }, 1800);
    });
  });
})();